import { createContext, useContext } from 'react';

import type { getCourseCards_LoggedInHomeV1Resource_get_courseCards as CourseCardType } from 'bundles/course-cards/__generated__/getCourseCards';
import type { CourseNextStepCourseCompletedNextStep } from 'bundles/naptimejs/resources/__generated__/GuidedCourseNextStepsV1';

export type CourseCardsContextType = {
  loading: boolean;
  courseCards: Array<CourseCardType>;
  refetchCourseCardData: () => void;
  totalCourseCards: number;
  currentTab?: string;
  completedCourseCardsNextStepData: Array<{ id: string; nextStep: CourseNextStepCourseCompletedNextStep }>;
  completedCourseCardNextStepDataPending: boolean;
};

const CourseCardsContext = createContext<CourseCardsContextType | undefined>(undefined);

export const useCourseCards = () => {
  const context = useContext(CourseCardsContext);

  return {
    loading: context?.loading,
    courseCards: context?.courseCards,
    refetchCourseCardData: context?.refetchCourseCardData,
    totalCourseCards: context?.totalCourseCards,
    currentTab: context?.currentTab,
    completedCourseCardsNextStepData: context?.completedCourseCardsNextStepData,
    completedCourseCardNextStepDataPending: context?.completedCourseCardNextStepDataPending,
  };
};

export default CourseCardsContext;
